// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2e2Zn","additionalNotes":"styles_additionalNotes__3k__4","loginButton":"styles_loginButton__apti8"};